if (typeof AnnouncementBar !== 'function') {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;

      // Na starcie ustawiamy stan przycisków (jeśli jest tylko jeden, oba będą na "disabled")
      this.updateNavButtons();

      // Podpinamy obsługę kliknięć w przyciski "następny"/"poprzedni"
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.changeSlide('next');
        });
      }
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.changeSlide('prev');
        });
      }

      // Jeśli jest więcej niż jeden "block", odpalamy automatyczną rotację co 5 sekund
      if (this.length > 1) {
        this.autoRotateInterval = setInterval(() => {
          const nextIndex = (this.index + 1) % this.length;
          this.goToSlide(nextIndex);
        }, 5000); // 5000 ms = 5 sekund między zmianami; możesz to zmienić na dowolny inny interwał
      }
    }

    /**
     * Przełącza na konkretny slajd o numerze newIndex.
     * Scrolluje, ustawia indeks, aktualizuje stan przycisków.
     */
    goToSlide(newIndex) {
      this.index = newIndex;
      this.updateNavButtons();

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });
    }

    /**
     * Dodaje/usuwa klasę "disabled" na przyciskach prev/next
     * w zależności od aktualnej wartości this.index.
     */
    updateNavButtons() {
      // Jeśli przycisk „poprzedni” istnieje:
      if (this.prevButton) {
        if (this.index === 0) {
          this.prevButton.classList.add('announcement-bar__content-nav--disabled');
        } else {
          this.prevButton.classList.remove('announcement-bar__content-nav--disabled');
        }
      }
      // Jeśli przycisk „następny” istnieje:
      if (this.nextButton) {
        if (this.index === this.length - 1) {
          this.nextButton.classList.add('announcement-bar__content-nav--disabled');
        } else {
          this.nextButton.classList.remove('announcement-bar__content-nav--disabled');
        }
      }
    }

    /**
     * Obsługa ręcznego przełączenia slajdów.
     * Jeśli kierunek 'next' i nie jesteśmy na ostatnim – indeks+1.
     * Jeśli kierunek 'prev' i nie jesteśmy na pierwszym – indeks-1.
     * Następnie wywołujemy goToSlide().
     */
    changeSlide(direction) {
      let newIndex = this.index;

      if (direction === 'next' && this.index < this.length - 1) {
        newIndex = this.index + 1;
      } else if (direction === 'prev' && this.index > 0) {
        newIndex = this.index - 1;
      }

      // Jeżeli newIndex nie zmienił się, znaczy że jesteśmy na krawędzi i nic nie robimy
      if (newIndex !== this.index) {
        this.goToSlide(newIndex);
      }
    }
  }

  if (typeof customElements.get('announcement-bar') === 'undefined') {
    customElements.define('announcement-bar', AnnouncementBar);
  }
}
